module.exports = __webpack_public_path__ + "img/added.45076df5.svg";